var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _circle, _circle2, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBakgroundImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1106,
    height: 877,
    viewBox: "0 0 1106 877",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 126.798,
    x2: 1102.5,
    y2: 126.798,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 250.662,
    x2: 1102.5,
    y2: 250.662,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 374.527,
    x2: 1102.5,
    y2: 374.527,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 498.391,
    x2: 1102.5,
    y2: 498.391,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 622.256,
    x2: 1102.5,
    y2: 622.256,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 746.121,
    x2: 1102.5,
    y2: 746.121,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 91.5957,
    y1: 2.5,
    x2: 91.5957,
    y2: 874.331,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 324.114,
    y1: 2.5,
    x2: 324.114,
    y2: 874.331,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 556.631,
    y1: 2.50024,
    x2: 556.631,
    y2: 874.331,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 789.149,
    y1: 2.5,
    x2: 789.149,
    y2: 874.331,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1021.67,
    y1: 2.5,
    x2: 1021.67,
    y2: 874.331,
    stroke: "#3C1414",
    strokeOpacity: 0.15,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206.984,
    cy: 191.773,
    r: 40.7449,
    fill: "#3C1414",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.985,
    cy: 556.848,
    r: 40.7449,
    fill: "#3C1414",
    fillOpacity: 0.15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.588,
    cy: 682.885,
    r: 40.7449,
    fill: "#3C1414",
    fillOpacity: 0.15
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 900.192,
    cy: 556.848,
    r: 40.7449,
    fill: "#3C1414",
    fillOpacity: 0.15
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.588,
    cy: 191.773,
    r: 40.7449,
    fill: "#3C1414",
    fillOpacity: 0.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBakgroundImage);
export default __webpack_public_path__ + "static/media/Bakground-image.30189f8c521859a2482b2e2cd1c082c1.svg";
export { ForwardRef as ReactComponent };